<template>
  <div class="base-vote-button">
    <a
      :href="href"
      :target="targetBlank ? '_blank' : '_self'"
      class="base-vote-button__element"
      v-bind:class="{
        'has-icon-left': hasIconLeft,
        'has-icon-right': hasIconRight,
      }"
      v-if="href !== ''"
    >
      <slot>Text</slot>
    </a>

    <router-link
      :to="to"
      class="base-vote-button__element"
      v-bind:class="{
        'has-icon-left': hasIconLeft,
        'has-icon-right': hasIconRight,
      }"
      v-else-if="to !== ''"
    >
      <slot>Text</slot>
    </router-link>

    <button
      :disabled="disabled"
      :type="type"
      class="base-vote-button__element"
      role="button"
      v-bind:class="{
        'has-icon-left': hasIconLeft,
        'has-icon-right': hasIconRight,
        'is-loading': loading,
      }"
      v-else
    >
      <slot>Text</slot>
      <span class="base-vote-button__loader" v-show="loading"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseVoteButton',
  props: {
    disabled: Boolean,
    hasIconLeft: Boolean,
    hasIconRight: Boolean,
    isLoading: Boolean,
    type: {
      type: String,
      default: 'button',
      required: false,
    },
    to: {
      type: [Object, String],
      default: '',
      required: false,
    },
    href: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    isLoading: function () {
      if (this.isLoading) {
        this.loading = true;
      } else {
        setTimeout(() => (this.loading = false), 500);
      }
    },
  },
};
</script>

<style lang="scss">
.base-vote-button {
  display: inline-block;
  width: 100%;

  &__element {
    width: 100%;
    justify-content: center;
    align-items: center;
    align-self: center;
    background-color: $color-accent-100;
    border: 0;
    border-radius: $border-radius-root;
    color: $color-accent;
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    font-weight: bold;
    min-height: 44px;
    outline: none;
    padding: 4px;
    text-decoration: none;
    transition: all 200ms ease;
    text-transform: uppercase;

    &:hover,
    &:active {
      background-color: $color-accent-200;
    }

    &:disabled {
      box-shadow: none;
      cursor: not-allowed;
      background-color: $color-neutral-pale;
      color: $color-neutral;
    }

    &.is-loading {
      // Cache l'icone s'il y en a un, peu importe le côté
      // Le loader est affiché dans le template en haut
      .feather {
        display: none;
      }

      .base-vote-button__loader {
        animation: spinner-border 0.75s linear infinite;
      }
    }

    &.has-icon-right {
      > .feather {
        flex: none;
        height: 20px;
        margin-left: 8px;
        width: 20px;
      }
    }

    &.has-icon-left {
      > .feather {
        flex: none;
        height: 20px;
        margin-right: 8px;
        width: 20px;
      }

      &.is-loading {
        flex-direction: row-reverse;
      }
      .base-vote-button__loader {
        margin: 0 8px 0 0;
      }
    }
  }

  &__loader {
    border: 1px solid currentColor;
    border-radius: $border-radius-round;
    border-right-color: transparent;
    display: inline-block;
    height: 20px;
    margin-left: 8px;
    width: 20px;
  }
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
</style>
